import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../../lib/api";

const empty = { name: "", description: "", image: "", featured: false, archived: false };
const inp = "w-full border border-linen bg-white px-3 py-2.5 text-sm outline-none focus:border-pitch";

export default function AdminBrands() {
  const [brands, setBrands] = useState([]);
  const [form, setForm] = useState(empty);
  const load = () => api.get("/admin/brands").then((r) => setBrands(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/brands", form); toast.success("Brand added"); setForm(empty); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  const update = async (b) => { try { await api.put(`/admin/brands/${b.id}`, b); toast.success("Saved"); load(); } catch {} };
  const del = async (id) => { try { await api.delete(`/admin/brands/${id}`); toast.success("Deleted"); load(); } catch {} };

  return (
    <div className="max-w-4xl">
      <h1 className="font-serif text-3xl text-pitch mb-8">Brands</h1>
      <form onSubmit={create} className="bg-white border border-linen p-6 mb-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input required placeholder="Brand name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inp} data-testid="brand-name" />
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.featured} onChange={(e) => setForm({ ...form, featured: e.target.checked })} /> Featured</label>
        <textarea placeholder="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className={`${inp} sm:col-span-2`} rows={2} />
        <button type="submit" className="inline-flex items-center gap-2 bg-pitch text-ivory text-xs font-mono uppercase tracking-[0.15em] px-6 py-3 w-fit" data-testid="brand-add"><Plus className="w-4 h-4" /> Add Brand</button>
      </form>
      <div className="bg-white border border-linen divide-y divide-linen">
        {brands.map((b) => (
          <div key={b.id} className="flex items-center gap-4 p-4">
            <div className="flex-1">
              <div className="font-serif text-lg text-pitch">{b.name}</div>
              <div className="text-xs text-stonemuted">{b.description}</div>
            </div>
            <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={b.featured} onChange={() => update({ ...b, featured: !b.featured })} /> Featured</label>
            <button onClick={() => del(b.id)} className="p-2 text-stonemuted hover:text-vermilion"><Trash2 className="w-4 h-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
